module.exports = __webpack_public_path__ + "785f1355740ec9e85917fc4eb141a5b2.obj";